<template>
  <div class="articlemanagement">
    <Card :bordered="false">
      <div slot="title">
        <Row>
          <Col
            :xs="24"
            :sm="24"
            :md="6"
            :lg="6"
          >
          <Divider orientation="left">{{ langMap.loginLog[lang] }}</Divider>
          </Col>
          <Col
            :xs="24"
            :sm="24"
            :md="18"
            :lg="18"
          >
          <Form :label-width="100">
            <div class="des-cardTittle-box">
              <FormItem
                :label="langMap.logDescription[lang]"
                class="leftFlex"
              >
                <Input
                  v-model.trim="message "
                  :placeholder="langMap.logDescription[lang]"
                  clearable
                />
              </FormItem>
              <FormItem
                :label="langMap.operator[lang]"
                class="leftFlex"
              >
                <Input
                  v-model.trim="operatorName"
                  :placeholder="langMap.operator[lang]"
                  clearable
                />
              </FormItem>
              <FormItem
                :label="langMap.operatorRole[lang]"
                class="leftFlex"
              >
                <Input
                  v-model.trim="roleName"
                  :placeholder="langMap.operatorRole[lang]"
                  clearable
                />
              </FormItem>
              <Button
                type="info"
                style="margin-left:20px;"
                @click="searchData"
              >{{ langMap.search[lang] }}</Button>
              <Button
                type="error"
                style="margin-left:20px;"
                @click="downData"
              >{{ langMap.download[lang] }}</Button>
            </div>
          </Form>
          </Col>
        </Row>
      </div>
      <Table
        :height="height"
        :loading="tableLoading"
        border
        :columns="col"
        :data="list"
      ></Table>
      <!--分页数据-->
      <div
        style="text-align:center;padding-top:10px;"
        v-if="list.length>0"
      >
        <Page
          :current="index"
          :total="total"
          :page-size="15"
          @on-change="goPageData"
        ></Page>
      </div>
    </Card>
  </div>
</template>

<script>
import api from "../../../api/index.js";
import langMap from '@/utils/language';
import { mapState } from 'vuex';
export default {
  components: {},
  data() {
    return {
      langMap:langMap,
      height: document.documentElement.clientHeight - 300,
      levelList: [],
      btnLoading: false,
      saveModal: false,
      
      list: [],
      index: 1,
      total: 0,
      //表格
      tableLoading: false,
      operatorName: "",
      message: "",
      roleName: "",
      type: ""
    };
  },
  computed: {
    ...mapState({
      lang: state => state.app.language,
    }),
    col() {
      return [
        {
          title: "#",
          width: 80,
          key: "index",
          render(h, params) {
            return h("span", params.index + 1);
          }
        },
        {
          title: langMap.groupId[this.lang],
          minWidth: 150,
          key: "groupId"
        },
        {
          title: langMap.logDescription[this.lang],
          minWidth: 120,
          key: "message"
        },
        {
          title: langMap.operator[this.lang],
          minWidth: 120,
          key: "operatorName"
        },
        {
          title: langMap.operatorRoleName[this.lang],
          minWidth: 120,
          key: "operatorRoleName"
        },
        {
          title: langMap.createTime[this.lang],
          minWidth: 150,
          key: "createTime",
          render(h, params) {
            var text = "";
            if (params.row.createTime) {
              text = params.row.createTime;
            } else {
              text = "-";
            }
            return h("span", text);
          }
        }
      ]
    }
  },
  methods: {
    downData() {
      api.download(
        "log-server/export/login/log?operatorName=" +
          this.operatorName +
          "&message=" +
          this.message +
          "&roleName=" +
          this.roleName,
        "登录日志"
      );
    },
    //获取列表
    getList() {
      this.tableLoading = true;
      api
        .getData(
          "log-server/log/list?index=" +
            this.index +
            "&operatorName=" +
            this.operatorName +
            "&message=" +
            this.message +
            "&type=1&roleName=" +
            this.roleName,
          this
        )
        .then(res => {
          if (res.state == 0) {
            this.$Notice.error({
              title: langMap.tip[this.lang],
              desc: res.msg
            });
          } else {
            this.list = res.data.rows;
            this.total = res.data.total;
          }
          this.tableLoading = false;
        });
    },
    //搜索数据
    searchData() {
      this.index = 1;
      this.getList();
    },
    //分页数据
    goPageData(index) {
      this.index = index;
      this.getList();
    },
    getDic() {
      this.tableLoading = true;
      api.getData("log-server/log/dic", this).then(res => {
        if (res.state == 0) {
          this.$Notice.error({
            title: langMap.tip[this.lang],
            desc: res.msg
          });
        } else {
          this.levelList = res.data;
        }
        this.tableLoading = false;
      });
    }
  },
  created() {
    this.getDic();
    this.getList();
  }
};
</script>

<style>
</style>
